import { axiosInstance } from '../../../api';
const BASE_PATH = '/hiring_pipeline';

//get  pipelines
export let getAllPipelineList = async (pipeline) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_pipeline_list_for_filter', {
            hiring_pipeline: pipeline
        })
        return value;
    } catch (error) {
        return error
    }
}

//get filters
export let getCandidateFilters = async (pipelineID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_candidate_filters', {
            hiring_pipeline: pipelineID,
        })
        return value;
    } catch (error) {
        return error
    }
}

//get candidates by filter
export let getFilteredCandidates = async (pipelineID, stageID, stepID, typeID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_candidates_by_filters', {
            hiring_pipeline: pipelineID,
            filter_level_one: stageID,
            filter_level_two: stepID,
            filter_level_three: typeID
        })
        return value;
    } catch (error) {
        return error
    }
}


//get  canididate list by search
export let getCandidateSearchList = async (searchText) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_candidates_by_search', {
            search_string: searchText
        })
        return value;
    } catch (error) {
        return error
    }
}